import { createFileRoute } from '@tanstack/react-router'
import { ContractsSection } from '~/components/marketing/contracts-section'
import { DocumentsSection } from '~/components/marketing/documents-section'
import { MarketingShell } from '~/components/marketing/marketing-shell'
import { ReportsSection } from '~/components/marketing/reports-section'
import { marketingPageHead } from '~/lib/site-meta'

const PAGE_TITLE = 'Entregáveis — documentos, relatórios e contratos | Planno'
const PAGE_DESCRIPTION =
  'Documentos colaborativos, relatórios mensais com templates e contratos blindados com assinatura digital. Tudo o que chega ao cliente sai com a identidade do escritório.'

export const Route = createFileRoute('/recursos/entregaveis')({
  component: EntregaveisPage,
  head: () =>
    marketingPageHead({
      description: PAGE_DESCRIPTION,
      locale: 'pt-BR',
      path: '/recursos/entregaveis',
      title: PAGE_TITLE,
    }),
})

function EntregaveisPage() {
  return (
    <MarketingShell>
      <DocumentsSection headingLevel="h1" />
      <ReportsSection />
      <ContractsSection />
    </MarketingShell>
  )
}
